import { prop } from 'ramda';
export const isJanusUser = prop('loggedInToJanus');
